export default "/_next/static/images/co-development-bg-64116759f6ff50b0307555b45f7e6d67.webp";